import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { QuestionnaireService } from "../../services/questionnaire.service";
import { SnackbarService } from "../../services/snackbar.service";
import { Questionnaire } from "../../classes/flow/Questionnaire/Questionnaire";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { TranslateService } from "@ngx-translate/core";
import { specialCharValidator } from "../../validators/specialChars";

@Component({
  selector: "app-new-questionnaire",
  templateUrl: "./new-questionnaire.component.html",
  styleUrls: ["./new-questionnaire.component.less"],
})
export class NewQuestionnaireComponent {
  public questionnaireForm: FormGroup = new FormGroup({
    specialties: new FormControl([], Validators.required),
    title: new FormControl("", [Validators.required, specialCharValidator]),
    description: new FormControl("", [Validators.required, specialCharValidator]),
    questionnaireType: new FormControl("", Validators.required),
  });

  constructor(
    private readonly translateService: TranslateService,
    private readonly questionnaireService: QuestionnaireService,
    private readonly snackbarService: SnackbarService,
    private readonly router: Router
  ) {}

  /**
   * Saves the user input as a new questionnaire
   */
  public async saveQuestionnaire() {
    if (this.questionnaireForm.valid) {
      try {
        await this.questionnaireService.createQuestionnaire(this.makeQuestionnaire());
        this.router.navigate(["content/coordinator/all-questionnaires"]);
      } catch (error) {
        this.snackbarService.open(this.translateService.instant("FORMS.NEW_QUESTIONNAIRE.FAILURE_MESSAGE"));
      }
    }
  }

  /**
   * Builds a questionnaire from the individual input values
   * @returns The questionnaire based on the user's input
   * The .replace is needed due to the user being able to cause grapqhl errors with certain special characters
   */
  private makeQuestionnaire(): Questionnaire {
    const data = this.questionnaireForm.value;
    return {
      active: false,
      title: data.title,
      description: data.description,
      questionnaireType: data.questionnaireType,
      specialties: data.specialties,
      sortOrder: null,
    };
  }
}
